
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'assignments/DueDateOverride';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<ul class=\"due-date-overrides\"></ul>\n";
  });
    ;
    
    import brandableCss from 'compiled/util/brandableCss';
    brandableCss.loadStylesheet('jst/assignments/DueDateOverride', {"new_styles_normal_contrast":{"combinedChecksum":"4f1128c399"},"new_styles_high_contrast":{"combinedChecksum":"82b4368a3b"},"responsive_layout_normal_contrast":{"combinedChecksum":"4f1128c399"},"responsive_layout_high_contrast":{"combinedChecksum":"82b4368a3b"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"a55639575e"},"new_styles_high_contrast_rtl":{"combinedChecksum":"fa90fdd623"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"a55639575e"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"fa90fdd623"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  